import { AsyncPipe, Location } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { SavingsPlanAmountPipe } from '@zero/onboarding/domain';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { InputComponent } from '@zero/shared/ui-web-design-system';
import { commonRoutes } from 'constants/web-app-constants';
import { BehaviorSubject, filter } from 'rxjs';
import { OnboardingContainerComponent } from '../../../components/onboarding-container/onboarding-container.component';

@Component({
  imports: [OnboardingContainerComponent, TranslocoPipe, InputComponent, AsyncPipe, SavingsPlanAmountPipe],
  templateUrl: './create.component.html',
})
export class CreateComponent implements OnInit {
  readonly #location = inject(Location);
  readonly #facade = inject(SavingsPlanFacade);
  readonly #destroyRef = inject(DestroyRef);
  readonly #route = inject(ActivatedRoute);
  readonly #router = inject(Router);
  readonly #amount = new BehaviorSubject<string>(undefined);

  public readonly amount$ = this.#amount.asObservable();

  public ngOnInit(): void {
    this.#setAmountFromCache();
    this.#facade.onboardingSavingsPlanCached$
      .pipe(
        filter((cached) => !!cached),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => this.#router.navigateByUrl(commonRoutes.postlogin.onboarding.savingsPlan.confirm));
  }

  public goBack = () => this.#location.back();
  public handleAmountChange = (amount: string) => this.#amount.next(amount);
  public goForward = () => this.#facade.cacheOnboardingSavingsPlan(Number(this.#amount.value), this.#route.snapshot.paramMap.get('isin'));

  readonly #setAmountFromCache = () => {
    this.#facade.onboardingSavingsPlanAmount$
      .pipe(
        filter((amount) => !!amount),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe((amount) => this.#amount.next(amount.toString()));
  };
}
